import request from '@/utils/request'

export function loginApi(data) {
  return request({
    url: '/auth-service/v1/login',
    method: 'post',
    data
  })
}

export function logoutApi() {
  return request({
    url: '/auth-service/v1/logout',
    method: 'post'
  })
}

export function getUserListPathApi() {
  return request({
    url: '/auth-service/v1/list-path',
    method: 'get'
  })
}

export function changePasswordApi(data) {
  return request({
    url: '/config-service/v1/account/update-password-by-user',
    method: 'put',
    data
  })
}

export function getAuthorizedListApi() {
  return request({
    url: '/config-service/v1/account/assign',
    method: 'get'
  })
}

export function getUserInfo(data) {
  return request({
    url: '/auth-service/v1/user-info',
    method: 'get',
    data
  })
}
